import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  TextField,
  Collapse,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import Input from "@material-ui/core/Input";

import Alert from "@material-ui/lab/Alert";
import { withAlert } from "react-alert";
import Layout from "../../components/Layout";
import store from "../../stores/copyStore";
import { OutTable, ExcelRenderer } from "react-excel-renderer";

const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
  cardDiv: {
    maxWidth: "100%",
  },
  cardBtn: {
    width: "100%",
  },
});

const View = observer(
  class CopyForm extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        url: "http://211.41.176.82",
        loc: "SWCL",
      };
    }
    handleChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value,
      });
    };
    fileHandler = (event) => {
      let fileObj = event.target.files[0];

      //just pass the fileObj as parameter
      ExcelRenderer(fileObj, (err, resp) => {
        if (err) {
          this.alert.show(err);
        } else {
          console.log(resp);
          store.setCols(resp.cols);
          store.setRows(resp.rows);
        }
      });
    };

    handleClick = () => {
      store.startJob(this.state.url, this.state.loc);
    };

    render() {
      const { classes } = this.props;
      const { blocking } = toJS(store);
      return (
        <div className={classes.cardDiv}>
          <Card elevation={5}>
            <CardHeader title="복본체크" />
            <CardContent>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="url"
                label="url"
                type="text"
                id="url"
                value={this.state.url}
                onChange={this.handleChange}
                disabled={blocking}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="loc"
                label="loc"
                type="text"
                id="loc"
                value={this.state.loc}
                onChange={this.handleChange}
                disabled={blocking}
              />
              {!blocking && (
                <input
                  type="file"
                  onChange={this.fileHandler.bind(this)}
                  style={{ padding: "10px" }}
                />
              )}
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.cardBtn}
                onClick={this.handleClick}
                disabled={blocking}
              >
                시작하기
              </Button>
            </CardActions>
          </Card>
        </div>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
